import { render, staticRenderFns } from "./BLanguageSwitcher.vue?vue&type=template&id=5e0d2686&scoped=true"
import script from "./BLanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BLanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BLanguageSwitcher.vue?vue&type=style&index=0&id=5e0d2686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d2686",
  null
  
)

export default component.exports